import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import AppShell from "./components/AppShell";
import PeopleSearchPage from "./pages/PeopleSearchPage";
import TeamsConfigPage from "./pages/TeamsConfigPage";
import type { HostMode } from "./teams/teamsContext";

export default function App() {
  const location = useLocation();
  const hostMode = useMemo<HostMode>(() => {
    if (location.pathname.startsWith("/teams")) {
      return "teams";
    }

    if (location.pathname.startsWith("/sharepoint")) {
      return "sharepoint";
    }

    return "web";
  }, [location.pathname]);

  if (location.pathname.startsWith("/teams/config")) {
    return <TeamsConfigPage />;
  }

  return (
    <AppShell hostMode={hostMode}>
      {(me) => <PeopleSearchPage me={me} hostMode={hostMode} />}
    </AppShell>
  );
}
